"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const leaflet_1 = __importDefault(require("leaflet"));
const artillery_svg_1 = __importDefault(require("../../assets/icons/artillery.svg"));
const ArtilleryIcon = new leaflet_1.default.Icon({
    iconUrl: artillery_svg_1.default,
    iconRetinaUrl: artillery_svg_1.default,
    iconSize: [35, 35],
});
exports.default = ArtilleryIcon;
